<div class="flex items-center justify-center min-h-screen p-4">
    <div class="flex flex-col items-center">
        <form [formGroup]="authForm" (ngSubmit)="submit()">
            <!-- Auth Box -->
            <div
                class="w-full max-w-[600px] sm:min-w-[544px] rounded-[20px] border border-[#E2E8F0] bg-white/90 my-4 xxxl:my-6 p-8 space-y-6 shadow-xl backdrop-blur">
                <div class="flex flex-col items-center">
                    <!-- Logo -->
                    <img src="/assets/images/auth/interseed-new-logo.png" alt="interseed logo" class="h-16 w-auto" />

                    <!-- Welcome Text -->
                    <div class="text-center mt-6">
                        <p class="text-[#0A0A0A] text-xl font-semibold">Welcome to Interseed</p>
                        <p class="text-[#4A5565] text-sm mt-2">
                            Choose how you'd like to get started, we'll walk you through the rest
                        </p>
                    </div>
                </div>
                <div class="flex flex-col space-y-4">
                    <!-- Social Buttons -->
                    <button type="button" class="w-full white-border-button" (click)="loginWithGoogle()">
                        <img src="/assets/images/auth/google-logo.png" alt="Google" class="h-5 w-5 mr-2" />
                        <p class="text-[#0A0A0A] text-sm font-semibold">Continue with Google</p>
                    </button>

                    <button type="button" class="w-full white-border-button" (click)="loginWithFacebook()">
                        <img src="/assets/images/auth/facebook-logo.png" alt="Facebook" class="h-5 w-5 mr-2" />
                        <p class="text-[#0A0A0A] text-sm font-semibold">Continue with Facebook</p>
                    </button>

                    <button type="button" class="w-full white-border-button" (click)="loginWithApple()">
                        <img src="/assets/images/auth/apple-logo.png" alt="Apple" class="h-5 w-5 mr-2" />
                        <p class="text-[#0A0A0A] text-sm font-semibold">Continue with Apple</p>
                    </button>
                </div>

                <!-- Divider -->
                <div class="flex items-center py-6">
                    <div class="flex-grow border-t border-[#E7EAF0]"></div>
                    <span class="mx-3 text-xs text-[#717182] font-semibold uppercase tracking-wide"
                        >or continue with email</span
                    >
                    <div class="flex-grow border-t border-[#E7EAF0]"></div>
                </div>
                <div class="space-y-3">
                    <!-- Email Input -->
                    <div class="flex flex-col space-y-2">
                        <label for="email" class="text-xs text-[#0A0A0A] font-semibold uppercase">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            formControlName="email"
                            placeholder="Your@email.com"
                            class="w-full form-field-container" />
                        <!-- Error messages -->
                        @if (authForm.get('email')?.touched && authForm.get('email')?.errors) {
                            @if (authForm.get('email')?.errors?.['required']) {
                                <div class="text-red-500 text-[0.625rem]">Email Address is required.</div>
                            } @else if (authForm.get('email')?.errors?.['pattern']) {
                                <div class="text-red-500 text-[0.625rem]">Please enter a valid email.</div>
                            }
                        }
                    </div>
                    <!-- Email Button -->
                    <button type="submit" class="w-full border-button" [disabled]="authForm.invalid">Continue</button>
                </div>
                <div class="flex justify-center">
                    <input type="checkbox" class="checkbox-button mr-2" formControlName="isAgree" id="isAgree" />
                    <div class="flex items-center text-[0.75rem]">
                        <p class="text-[#717182]">
                            By continuing, you agree to our
                            <span class="text-[#4F66FF]">
                                <a href="https://interseed.io/terms-of-use/" target="_blank" rel="noopener noreferrer">
                                    Terms of Use
                                </a>
                                <span class="text-[#717182]">and</span>
                                <!-- <a
                                    href="https://interseed.io/privacy-policy/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    Privacy Policy
                                </a> -->
                                <a class="text-[#4F66FF] ml-1 cursor-pointer" [routerLink]="['/privacy-policy']">
                                    Privacy Policy
                                </a>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </form>
        <div class="version-container">
            <p class="text-[#717182] text-xs">{{ envName !== 'PRODUCTION' ? APP_VERSION : APP_PROD_VERSION }}</p>
        </div>
    </div>
</div>
